import type { ApolloError } from '@apollo/client';
import React, { createContext, useContext, useMemo } from 'react';

import type { GetCurrentUserQuery } from '../__generated__/graphql.js';

type CurrentUser = GetCurrentUserQuery['getCurrentUser'];

interface CurrentUserContextValue {
  user?: CurrentUser;
  loading: boolean;
  error?: ApolloError;
}

const CurrentUserContext = createContext<CurrentUserContextValue | undefined>(undefined);

export function CurrentUserProvider({
  value,
  children,
}: {
  value: CurrentUserContextValue;
  children: React.ReactNode;
}): React.JSX.Element {
  const memoed = useMemo(() => value, [value.user, value.loading, value.error]);
  return <CurrentUserContext.Provider value={memoed}>{children}</CurrentUserContext.Provider>;
}

export function useCurrentUser(): CurrentUserContextValue {
  const ctx = useContext(CurrentUserContext);
  if (!ctx) {
    throw new Error('useCurrentUser must be used within a CurrentUserProvider');
  }
  return ctx;
}
